import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import '../layout/sass/_pickListSugestoes.scss'
import '../layout/sass/_responsiveTable.scss'
import api from '../api/api';
import { InputNumber } from 'primereact/inputnumber';
import { FormFaturaItens } from './FormFaturaItens';


export const TabelaFaturaItens = ({ isEditing, atualizarFaturaItens, faturaItem }) => {
    const toast = useRef(null);
    const [faturaItens, setFaturaItens] = useState([]);
    const [totais, setTotais] = useState([]);
    const [instalacoes, setInstalacoes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [first, setFirst] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [sortable, setSortable] = useState('ASC');
    const [totalRecords, setTotalRecords] = useState(0);
    const [sortableCampo, setSortableCampo] = useState('id');
    const confirmationToast = useRef(null)
    const [dt, setDt] = useState(null);
    const { id } = useParams();
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 20,
        sortField: null,
        sortOrder: null,
        filters: {}
    });
    const history = useHistory();

    const [showModalUpdate, setShowModalUpdate] = useState(false);
    const [showModalView, setShowModalView] = useState(false);
    const [modalData, setModalData] = useState(null);


    const getFaturaItens = useCallback(async (event) => {
        setIsLoading(true);

        const startIndex = event ? event.first : 0;  // Iniciar de 0 caso o evento seja indefinido
        setFirst(startIndex);  // Atualize a página corrente

        // Construa os filtros com base no estado lazyParams
        const filters = lazyParams.filters || {};

        try {
            if (isEditing) {
                const page = event ? event.page : 0;  // Obtenha o número da página corretamente

                // Convertendo filtros para query params
                const filterParams = Object.keys(filters).map(key => {
                    return `${key}=${filters[key].value}`;
                }).join('&');

                // Monta a URL com filtros, página e ordenação
                const url = `faturaItem/faturaId/${id}?page=${page}&sort=${sortableCampo},${sortable}${filterParams ? '&' + filterParams : ''}`;

                const response = await api.get(url); //apenas uma requisicao
                const data = response.data;

                // Aqui é onde você adiciona a propriedade "retencao" em cada item
                const itensComRetencao = data.content.map((item) => {
                    const totalValorLancamento = item.faturaItemDetalhes?.reduce(
                        (acc, detalhe) => acc + (detalhe.valorLancamento || 0),
                        0
                    ) || 0;

                    const retencao = (totalValorLancamento - item.valorTotal) / 2;

                    const percentualRetencao = totalValorLancamento > 0
                        ? (retencao / totalValorLancamento) * 100
                        : 0;

                    return {
                        ...item,
                        valorRetencao: retencao || 0,
                        percentualRetencao: percentualRetencao.toFixed(2), // opcional: formato com 2 casas decimais como string
                    };
                });


                setFaturaItens(itensComRetencao);
                setTotalRecords(data.totalElements);

            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Erro ', detail: error.toString() });
        }
        setIsLoading(false);

    }, [sortable, sortableCampo, isEditing, id, lazyParams.filters]);  // Adicione lazyParams.filters à lista de dependências

    const getTotais = async () => {
        setTotais([])
        try {

            if (isEditing) {

                const respSomaFaturas = await api.get(`faturaItem/somaFaturas/${id}`);

                setTotais(respSomaFaturas.data)

            }

        }
        catch (error) {
            toast.current.show({ severity: 'error', summary: 'Erro ao obter faturas', detail: error.toString() });
        }
    }

    const updateItemDetalhe = (rowData) => {
        confirmDialog({
            message: `Deseja realmente atualizar o item: "${rowData.descLancamento}"?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sim',
            rejectLabel: 'Cancelar',
            accept: async () => {
                try {
                    const resp = await api.put(`/faturaItem/updateDetalhe/${rowData.descLancamento}`);
                    console.log(resp);
                    toast.current.show({
                        life: 2000,
                        severity: 'success',
                        summary: 'Item detalhe alterado!',
                        detail: 'Item detalhe alterado com sucesso',
                    });
                } catch (error) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Erro ao atualizar item detalhe',
                        detail: error.toString(),
                    });
                }
            }
        });
    };


    useEffect(() => {
        if (isEditing) {
            getFaturaItens({
                page: lazyParams.page ?? 0,
                first: lazyParams.first ?? 0,
                sortField: sortableCampo,
                sortOrder: sortable,
                filters: lazyParams.filters,
            });
        }
    }, [lazyParams.page, lazyParams.first, sortableCampo, sortable, lazyParams.filters, isEditing]);


    useEffect(() => {
        const fetchTotais = async () => {
            await getTotais(); //useEffect separado com as dependências corretas
        };

        if (isEditing) {
            fetchTotais();
        }
    }, [id, isEditing]);


    const actionBodyTemplate = (rowData) => {

        return (
            <div className="actions">

                <Button
                    type="button"
                    icon="pi pi-pencil"
                    className="p-button-rounded p-mr-2 p-button-edit"
                    loading={isDeleting}
                    onClick={() => handleEditClick(rowData)}
                />

                <Button
                    type="button"
                    icon="pi pi-trash"
                    className="p-button-rounded p-mr-2 p-button-danger"
                    loading={isDeleting}
                    onClick={() => handleDeleteClick(rowData)}
                />


            </div>
        );
    }

    const itemIdBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Item</span>
                    <span className="table-data">{rowData.id ? rowData.id : ""}</span>
                </p>
            </React.Fragment>
        );
    }

    const instalacaoIdBodyTemplate = (rowData) => {
        
        return (
            <React.Fragment>
                <p style={{ textAlign: 'left' }}>
                    <span className="p-column-title">Instalação</span>
                    <span className="table-data">{rowData.instalacao?.numeroInstalacao || ""}</span>
                </p>
            </React.Fragment>
        );
    };




    const descricaoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Descrição Fatura</span>
                    <span className="table-data">{rowData.instalacao?.descricao || ""}</span>
                </p>
            </React.Fragment>
        );
    }



    const enderecoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Endereço</span>
                    <span className="table-data">{rowData.instalacao?.endereco || ""}</span>
                </p>
            </React.Fragment>
        );
    }

    const empenhoBodyTemplate = (rowData) => {

        const listInstalacaoEmpenho = rowData.instalacao?.listInstalacaoEmpenho || [];

        const ativos = listInstalacaoEmpenho.filter(item => item.ativo === true);

        console.log(rowData);


        return (
            <React.Fragment>
                <p style={{
                    display: 'flex',
                    alignItems: 'center', // Alinha o conteúdo verticalmente no centro
                    justifyContent: 'flex-start', // Alinha o conteúdo na direção horizontal
                    textAlign: 'left',
                }}>
                    <span className="p-column-title">Empenho</span>
                    <span className="table-data" style={{ marginLeft: '10px' }}>
                        {/* Aqui, caso a lista de empenhos ativas não esteja vazia, exibe a lista */}
                        {ativos.length > 0 ? (
                            <>
                                <div>Empenhos: {ativos.length}</div>
                                <div>Peso: {ativos.reduce((total, item) => total + item.peso, 0)}</div>
                            </>

                        ) : (
                            <span>0</span>
                        )}
                    </span>
                    <Button
                        icon="pi pi-pencil"
                        className="p-button-rounded p-mr-2 edit-btn"
                        style={{ marginLeft: '10px' }} // Adiciona espaço entre o botão e o conteúdo anterior
                        onClick={() => handleEditInstalacaoClick(rowData)}
                    />
                </p>
            </React.Fragment>

        );
    }

    const quantidadeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Quantidade</span>
                    <span className="table-data">{rowData.quantidade ? rowData.quantidade.toLocaleString('pt-BR') : ""}</span>
                </p>
            </React.Fragment>
        );
    }

    const unidadeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Unidade</span>
                    <span className="table-data">{rowData.unidade ? rowData.unidade : ""}</span>
                </p>
            </React.Fragment>
        );
    }

    const valorTotalBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Valor Total</span>
                    <span className="table-data">{rowData.valorTotal ? rowData.valorTotal.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }) : ""}</span>
                </p>
            </React.Fragment>
        );
    }

    const valorRetencaoBodyTemplate = (rowData) => (
        <p style={{ textAlign: 'left' }}>
            <span className="p-column-title">Retenção</span>
            <span className="table-data">
                {rowData.valorRetencao.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                })}
            </span>
            <span> - </span>
            <span className="table-data">
                {rowData.percentualRetencao.toLocaleString('pt-BR', {
                    currency: 'BRL',
                })}%
            </span>
        </p>
    );


    const handleEditClick = (data) => {



        if (data.instalacao !== null) {
            setModalData(data);
            setShowModalView(true);
            setShowModalUpdate(false);
        } else {
            const updatedData = {
                id: data.id,
                faturaId: id,
                instalacaoId: "",
                quantidade: data.quantidade ?? 1,
                valorTotal: data.valorTotal ?? 0,
                valorRetencao: data.valorRetencao ?? 0,
            };

            setModalData(updatedData);
            setShowModalView(false);
            setShowModalUpdate(true);

        }
    };


    const handleHide = () => {
        setShowModalView(false);
        setShowModalUpdate(false);
    }

    const handleDeleteClick = (data) => {

        let tempFaturas = [];
        confirmDialog({
            message: `Você tem certeza que quer remover ${data.descricaoFatura}?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: async () => {
                setIsDeleting(true);

                try {

                    const response = await api.delete(`faturaItem/${data.id}`);

                    setFaturaItens(faturaItens.filter(item => item !== data));
                    faturaItens.filter(item => item !== data).forEach(item => {
                        tempFaturas.push(item.muda)
                    });
                    toast.current.show({ life: 5000, severity: 'success', summary: 'Remoção concluída!', detail: `Instalação ${data.descricao} removida com sucesso` });

                }
                catch (error) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'Erro ao remover a muda', detail: error.response.data });
                }

                setIsDeleting(false);

                await getTotais(); //Espera a execucao de getTotais
            }

        });
    }


    useEffect(() => {

    }, [faturaItens]);

    const onRowEditComplete1 = (e) => {
        let faturaItens2 = [...faturaItens];
        let { newData, index } = e;

        faturaItens2[index] = newData;

        setFaturaItens(faturaItens2);
    }

    const handleEditInstalacaoClick = (data) => {
        history.push(`/instalacao/edit/${data.instalacao.id}`, {
            from: `/faturas/edit/${id}`
        });
    };

    const handleEdit = (data, campo, value) => {
        data[campo] = value;
        atualizarFaturaItens(faturaItens);
    }

    const editarQuantidade = (options) => {

        return <InputNumber value={options.rowData.quantidade} onValueChange={((e) => { handleEdit(options.rowData, 'quantidade', e.value) })} mode="decimal" minFractionDigits={2} maxFractionDigits={2} currency="BRL" locale="pt-BR" />

    }

    const onFilter = (event) => {
        // Atualiza os parâmetros de filtro no estado lazyParams
        setLazyParams({
            ...lazyParams,
            filters: event.filters
        });

        // Sempre começa a partir da primeira página ao aplicar o filtro
        event.first = 0;
        setLazyParams(event);
    }

    const onSort = (event) => {

        const newSortField = event.sortField === "instalacaoId" ? "instalacao.id" : event.sortField;

        const newSortOrder = sortable === 'ASC' ? 'DESC' : 'ASC';  // Ordenação crescente ou decrescente

        setSortableCampo(newSortField);
        setSortable(newSortOrder);

        // Atualiza os parâmetros de busca com o novo campo e ordem
        setLazyParams((prevParams) => ({
            ...prevParams,
            sortField: newSortField,
            sortOrder: newSortOrder,
        }));
    };


    const formatarMoeda = (valor) => {
        return valor ? valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00';
    };

    return (

        <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">

            <Toast ref={toast} position="bottom-right" />

            <Toast ref={confirmationToast} position="bottom-center" />

            <div className="card p-col-12 datatable-responsive-demo">

                <div className="p-fluid">


                    <DataTable
                        totalRecords={totalRecords}
                        lazy
                        first={first}
                        onPage={getFaturaItens}  // Esta chamada vai passar o evento para o getFaturaItens
                        filterDisplay="row"
                        loading={isLoading}
                        editMode="row"
                        onRowEditComplete={onRowEditComplete1}
                        responsiveLayout="scroll"
                        value={faturaItens}
                        className="p-datatable-responsive-demo"
                        emptyMessage="Nenhuma fatura encontrada"
                        dataKey="id"
                        paginator
                        rows={20}
                        currentPageReportTemplate={`Mostrando de {first} a {last} de ${totalRecords} faturas`}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        onSort={onSort}
                        onFilter={onFilter}
                        filters={lazyParams.filters}
                    >



                        {/* <Column
                            field="itemId"
                            header="Item"
                            footer=""
                            sortable
                            body={itemIdBodyTemplate}
                            style={{ textAlign: "center" }}
                        /> */}

                        <Column
                            field="instalacao.numeroInstalacao"  // Ajuste para acessar o campo correto
                            header="Instalação.."
                            footer=" "
                            sortable
                            body={instalacaoIdBodyTemplate}
                            style={{ textAlign: "center" }}
                            filter
                            filterMatchMode="contains"
                            filterPlaceholder="Pesquisar por Instalação"
                        />

                        {/* <Column
                            field="instalacaoId"
                            header="Instalação"
                            footer=" "
                            sortable
                            body={instalacaoIdBodyTemplate}
                            style={{ textAlign: "center" }}
                            filter
                            filterMatchMode="contains"
                            filterPlaceholder="Pesquisar por Instalação"

                        /> */}


                        <Column
                            field="descricao"
                            header="Descrição"
                            footer=" "
                            sortable
                            body={descricaoBodyTemplate}
                            style={{ textAlign: "center" }}
                        />

                        <Column
                            field="endereco"
                            header="Endereço"
                            footer=" "
                            sortable
                            body={enderecoBodyTemplate}
                            style={{ textAlign: "center" }}
                        />

                        <Column
                            field="empenho"
                            header="Empenho"
                            footer=" "
                            sortable
                            body={empenhoBodyTemplate}
                            style={{ textAlign: "center" }}
                        />

                        <Column
                            field="quantidade"
                            header="Quantidade"
                            footer="Total da Fatura:"
                            sortable
                            body={quantidadeBodyTemplate}
                            // editor={(options) => editarQuantidade(options)}
                            style={{ width: '10%' }}
                        />

                        {/* <Column
                            rowEditor
                            headerStyle={{ width: '10%', minWidth: '8rem' }}
                            bodyStyle={{ textAlign: 'center' }}
                            footer=" "
                            style={{ textAlign: "center" }}>

                        </Column> */}

                        {/* <Column
                            field="unidade"
                            header="Unidade"
                            footer=" "
                            sortable
                            body={unidadeBodyTemplate}
                            style={{ textAlign: "center" }}
                        /> */}

                        <Column
                            field="valorTotal"
                            header="Valor Total"
                            footer={formatarMoeda(totais.valorTotal)}
                            sortable
                            body={valorTotalBodyTemplate}
                            style={{ textAlign: "center" }}
                        />

                        <Column
                            field="valorRetencao"
                            header="Retenção"
                            footer={formatarMoeda(totais.valorRetencao)}
                            sortable
                            body={valorRetencaoBodyTemplate}
                            style={{ textAlign: "center" }}
                        />

                        <Column
                            header="Ações"
                            body={actionBodyTemplate}

                        />


                    </DataTable>

                </div>
            </div>

            <Dialog
                header="Detalhes da Instalação"
                visible={showModalView}
                onHide={handleHide}
                style={{ width: '70vw' }}
            >
                {modalData && (
                    <div>
                        <h2>Instalação: {modalData.instalacao?.numeroInstalacao || ""}</h2>
                        <p><strong>Endereço:</strong> {modalData.instalacao?.endereco || ""}</p>
                        <p><strong>Medidor:</strong> {modalData.instalacao?.medidor || ""}</p>
                        <p><strong>Responsável:</strong> {modalData.instalacao?.responsavel || 'Não informado'}</p>
                        <p><strong>Quantidade:</strong> {modalData.quantidade}</p>
                        <p><strong>Valor Unitário:</strong> {modalData.valorUnitario ? modalData.valorUnitario.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        }) : ""}</p>
                        <p><strong>Valor Total:</strong> R$ {modalData.valorTotal ? modalData.valorTotal.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        }) : ""}</p>

                        <h3>Detalhamento da Instalação na Fatura</h3>
                        <DataTable value={modalData.faturaItemDetalhes} paginator rows={10} rowsPerPageOptions={[5, 10, 20]}>
                            <Column field="codLancamento" header="Código" sortable style={{ width: '8%' }} />
                            <Column field="dataLancamento" header="Data" sortable style={{ width: '8%' }} />
                            <Column field="descLancamento" header="Descrição" sortable style={{ width: '35%' }} />
                            <Column field="valorLancamento" header="Valor" body={(rowData) => `R$ ${rowData.valorLancamento.toFixed(2)}`} sortable style={{ width: '8%' }} />
                            <Column
                                header="Ações"
                                body={(rowData) => (
                                    <Button
                                        label="Remover Valor"
                                        icon="pi pi-trash"
                                        onClick={() => updateItemDetalhe(rowData)}
                                        className="p-button-sm p-button-info"
                                    />
                                )}
                                style={{ width: '10%' }}
                            />
                        </DataTable>
                    </div>
                )}
            </Dialog>

            {showModalUpdate && (
                <Dialog
                    header="Formulário Alterar Item"
                    visible={showModalUpdate}
                    onHide={handleHide}
                    breakpoints={{ '960px': '75vw', '640px': '100vw' }}
                    style={{ width: '75vw' }}
                >
                    <FormFaturaItens
                        isEditing={false}  // Porque no seu fluxo editar só é quando data.instalacao !== null, certo?
                        isLoading={isLoading}
                        setFaturaItem={atualizarFaturaItens}
                        modalData={modalData}  // IMPORTANTE: passe modalData para o form
                        faturaId={id}
                    />
                </Dialog>
            )}

        </div >

    );
}
